import { __rest } from 'tslib';
import React from 'react';
import { useControllableState } from '@10d/tend-ui-hooks';
import { useTheme } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { Root } from './styled.js';
import { Group } from './Group/Group.js';
import { useToggleButtonGroupContext } from './context.js';
import styles from './ToggleButton.module.css.js';

const BaseToggleButton = (_a, ref) => {
    var { onClick, selectable = true, selected, onSelectedChange, className } = _a, props = __rest(_a, ["onClick", "selectable", "selected", "onSelectedChange", "className"]);
    const theme = useTheme();
    const context = useToggleButtonGroupContext();
    const [_selected, _setSelected] = useControllableState({
        value: selected,
        defaultValue: false,
        onChange: onSelectedChange,
    });
    const handleClick = React.useCallback((e) => {
        var _a;
        if (props.disabled === true)
            return;
        (_a = context === null || context === void 0 ? void 0 : context.onChange) === null || _a === void 0 ? void 0 : _a.call(context, e, e.currentTarget.value);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
        if (!selectable)
            return;
        _setSelected(!_selected);
    }, [_selected, _setSelected, context, onClick, props.disabled, selectable]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-toggle-button', "aria-pressed": _selected, "aria-disabled": props === null || props === void 0 ? void 0 : props.disabled }, props, { ref: ref, "$selected": selectable ? _selected : false, theme: theme, onClick: handleClick, className: cn([styles['tend-ui-toggle-button'], className], {
            [styles['tend-ui-toggle-button-selected']]: selected,
            [styles['tend-ui-toggle-button-disabled']]: props.disabled,
        }) })));
};
const ForwardedToggleButton = React.forwardRef(BaseToggleButton);
const ToggleButton = Object.assign(ForwardedToggleButton, {
    displayName: 'ToggleButton',
    Group,
});

export { ToggleButton };
